import { render } from "./BottomNavBar.vue?vue&type=template&id=cc484774&scoped=true"
import script from "./BottomNavBar.vue?vue&type=script&lang=js"
export * from "./BottomNavBar.vue?vue&type=script&lang=js"

import "./BottomNavBar.vue?vue&type=style&index=0&id=cc484774&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc484774"]])

export default __exports__